import { styled, css } from 'styled-components';

import { verticalFadeIn, verticalFadeOut } from '../../theme/animations.ts';
import { ANIMATION_DURATION_MS } from './constants.ts';

interface WrapperProps {
  $minWidth: boolean;
  $zIndex?: number;
  $trackHiddenReference?: boolean;
  $maxHeight?: number;
  $visible: boolean;
  $isTop?: boolean;
}

export const Wrapper = styled.div<WrapperProps>`
  ${({ theme }) => theme.shadows.large};
  padding: 5px 0;
  list-style: none;
  border-radius: 4px;
  background: ${({ theme }) => theme.colors.grey00_6};
  z-index: ${({ $zIndex }) => $zIndex};
  min-width: ${({ $minWidth }) => $minWidth && '160px'};
  animation: ${({ $visible, $isTop }) => ($visible ? verticalFadeIn($isTop) : verticalFadeOut($isTop))} ${ANIMATION_DURATION_MS}ms ease
    forwards;

  ${({ $trackHiddenReference }) =>
    $trackHiddenReference &&
    css`
      &[data-popper-reference-hidden='true'] {
        &,
        & * {
          visibility: hidden;
          pointer-events: none;
          transition: none;
        }
      }
    `}

  ${({ $maxHeight }) =>
    $maxHeight &&
    css`
      max-height: ${$maxHeight}px;
      overflow: auto;
    `}
`;

export const ButtonWrapper = styled.div<{ $block?: boolean }>`
  display: ${({ $block }) => ($block ? 'block' : 'inline-flex')};
  ${({ $block }) =>
    $block &&
    css`
      width: 100%;
    `}
`;

export const ButtonComponent = styled.div`
  display: inline-flex;
`;

export const SubmenuTrigger = styled.div`
  display: block;
  width: 100%;
`;

/**
 * Off-screen container used only to render a submenu's items while it is closed, so an empty
 * submenu (all items render `null` at runtime) can hide its trigger. `display: none` keeps it out
 * of the layout, the tab order and hit-testing while still allowing `childElementCount` measurement.
 */
export const MeasureProbe = styled.div`
  display: none;
`;
